module.exports = __webpack_public_path__ + "static/media/logo157.54135dca.png";